export interface OAuthStartResponse {
  oauthUrl: string
}

export interface OAuthStatusResponse {
  hasYandexAuth: boolean
  yaCounterID: string | null
  goalsCreated: string[]
  oauthUpdatedAt: string | null
}

const USE_MOCKS = false

let mockOAuthStartedAt = 0

export function resetMockYandex() {
  mockOAuthStartedAt = 0
}

export async function startYandexOAuth(channelUUID: string): Promise<OAuthStartResponse> {
  if (USE_MOCKS) {
    await new Promise((r) => setTimeout(r, 200))
    mockOAuthStartedAt = Date.now()
    return {
      oauthUrl: `https://oauth.yandex.ru/authorize?response_type=code&client_id=mock&state=mock-${channelUUID}`,
    }
  }
  const res = await fetch('/api/max/yandex/oauth-start', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ channelUUID }),
  })
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}

export async function getYandexOAuthStatus(channelUUID: string): Promise<OAuthStatusResponse> {
  if (USE_MOCKS) {
    await new Promise((r) => setTimeout(r, 150))
    if (mockOAuthStartedAt === 0) {
      return {
        hasYandexAuth: false,
        yaCounterID: null,
        goalsCreated: [],
        oauthUpdatedAt: null,
      }
    }
    const elapsed = Date.now() - mockOAuthStartedAt
    if (elapsed < 4000) {
      return {
        hasYandexAuth: false,
        yaCounterID: null,
        goalsCreated: [],
        oauthUpdatedAt: null,
      }
    }
    return {
      hasYandexAuth: true,
      yaCounterID: '103456789',
      goalsCreated: [
        'toChannel - переход',
        'userDidSubscribe - подписка',
        'userDidUnsubscribe - отписка',
      ],
      oauthUpdatedAt: new Date().toISOString(),
    }
  }
  const res = await fetch(
    `/api/max/projects/${encodeURIComponent(channelUUID)}/oauth-status`,
    { credentials: 'include' },
  )
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}

const GOAL_LABEL_MAP: Record<string, string> = {
  toChannel: 'Переход в канал',
  userDidSubscribe: 'Подписка',
  userDidUnsubscribe: 'Отписка',
}

export function goalLabel(rawName: string): string {
  const key = rawName.split(' - ')[0].trim()
  return GOAL_LABEL_MAP[key] || rawName
}
